import { render, staticRenderFns } from "./EnterRelationInformation.vue?vue&type=template&id=feb699fe"
import script from "./EnterRelationInformation.vue?vue&type=script&lang=js"
export * from "./EnterRelationInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports